module.exports = "<app-breadcrumb></app-breadcrumb>\r\n<div class=\"tab-content\" id=\"v-pills-tabContent\" *ngIf=\"isDataLoaded\">   \r\n    <app-pagination (setPageData)=\"setPageData($event)\" [itemsCount]=partGroups.length ></app-pagination>          \r\n    <h3 class=\"brand-color-text text-uppercase mb-3 text-center\">SELECT A PART GROUP</h3>\r\n    <app-card-view [viewData]=pagedItems></app-card-view>\r\n</div>\r\n  \r\n"


//////////////////
// WEBPACK FOOTER
// ./src/opc/opc-app/partgroup/partgroup.component.html
// module id = ./src/opc/opc-app/partgroup/partgroup.component.html
// module chunks = main